import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toDate, toDateFromPtBr } from '@/modules/core/utils/formats';

export const getPaginatedFeedbackData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`feedback?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllFeedbackData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`feedback?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.nomeUsuario}"`,
    `"${data.emailUsuario}"`,
    `"${toDate(data.dataHoraCriacao)}"`,
    `"${data.texto}"`,
  ]);
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataCriacaoInicial: toDateFromPtBr(options.creationInitialDate),
  dataCriacaoFinal: toDateFromPtBr(options.creationEndDate),
  incluirLidos: options.incluirLidos,
});

export const salvarComentario = async(comentario) => {
  const httpClient = authenticatedHttpClientFactory();
  try {
    const response = await httpClient.put(`/feedback/${comentario.uuid}`, comentario);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
